import { render, staticRenderFns } from "./TheLocaleChanger.vue?vue&type=template&id=1bf04684&scoped=true"
import script from "./TheLocaleChanger.vue?vue&type=script&lang=js"
export * from "./TheLocaleChanger.vue?vue&type=script&lang=js"
import style0 from "./TheLocaleChanger.vue?vue&type=style&index=0&id=1bf04684&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bf04684",
  null
  
)

export default component.exports